import { Text } from '@buffer-mono/popcorn'

import { EngagementMedia } from '../../components/EngagementMedia'
import { useMentionData } from '../context/MentionContext'

import type { JSX } from 'react'

type MentionMediaProps = {
  className?: string
}

/**
 * Renders the media attached to the current mention (`mention.assets`).
 * Context-bound wrapper around the presentational `EngagementMedia`.
 *
 * Networks serve mention media from short-lived urls (Instagram especially),
 * so a thumbnail can already be gone by the time the card renders. Hiding it
 * empties a media-only mention, which is why those get a line in place of the
 * strip; a mention with text still reads on its own and stays silent.
 */
export const MentionMedia = ({
  className,
}: MentionMediaProps): JSX.Element | null => {
  const mention = useMentionData()
  const hasText = Boolean(mention.text && mention.text.trim().length > 0)

  return (
    <EngagementMedia
      assets={mention.assets}
      className={className}
      fallback={
        hasText ? null : (
          <Text size="sm" color="subtle">
            This media is not available
          </Text>
        )
      }
    />
  )
}
